import { useContext, useEffect, useRef, useState } from 'react';
import EditorFilterFamilyOptionsSection from './EditorFilterFamilyOptionsSection';
import EditorObjectTypeSelectSection from './EditorObjectTypeSelectSection';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorFilterFamilySelectPanelContainer = styled.div.withConfig({
  displayName: "EditorFilterFamilySelectPanel__EditorFilterFamilySelectPanelContainer",
  componentId: "sc-130k5hx-0"
})(({
  theme
}) => ({
  borderRight: `1px solid ${theme.color['border-core-default']}`,
  display: `flex`,
  flexDirection: `column`,
  height: `100%`,
  width: `300px`
}));
const EditorFilterFamilySelectPanel = () => {
  const {
    conditionPathToChangeFieldFor,
    draftCondition,
    selectedFilterFamily
  } = useContext(SegmentationFiltersInstanceContext);
  const [isFilterFamilySelected, setIsFilterFamilySelected] = useState(!!selectedFilterFamily);
  const prevDraftConditionConditionPath = useRef(draftCondition === null || draftCondition === void 0 ? void 0 : draftCondition.conditionPath);
  useEffect(() => {
    if (prevDraftConditionConditionPath.current !== (draftCondition === null || draftCondition === void 0 ? void 0 : draftCondition.conditionPath)) {
      setIsFilterFamilySelected(!!selectedFilterFamily);
    }
    prevDraftConditionConditionPath.current = draftCondition === null || draftCondition === void 0 ? void 0 : draftCondition.conditionPath;
  }, [draftCondition === null || draftCondition === void 0 ? void 0 : draftCondition.conditionPath, selectedFilterFamily]);
  const isFilterFamilyPredefined = Boolean(draftCondition && draftCondition.isAddingNew && draftCondition.filterFamily);
  const shouldHidePanel = !!conditionPathToChangeFieldFor || isFilterFamilyPredefined;
  if (!draftCondition || isFilterFamilySelected && shouldHidePanel) {
    return null;
  }
  return /*#__PURE__*/_jsxs(EditorFilterFamilySelectPanelContainer, {
    children: [/*#__PURE__*/_jsx(EditorObjectTypeSelectSection, {}), /*#__PURE__*/_jsx(EditorFilterFamilyOptionsSection, {})]
  });
};
export default EditorFilterFamilySelectPanel;